module.exports = __webpack_public_path__ + "img/banner4.758cb36a.jpg";